import { baseApi, defaultQueryFreshness } from "./baseApi";

export const soldListingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSoldListings: builder.query<unknown, { cardName?: string; game?: string; cardId?: string } | string>({
      query: (arg) => {
        if (typeof arg === "string") {
          return { url: `/sold-listings/${encodeURIComponent(arg)}`, method: "GET" };
        }
        const { cardName, game, cardId } = arg || {};
        return { url: `/sold-listings`, method: "GET", params: { cardName, game, cardId } };
      },
      providesTags: (_res, _err, arg) => [{ type: "SoldListings", id: typeof arg === "string" ? arg : `${arg?.game || ""}:${arg?.cardId || arg?.cardName || ""}` }],
      ...defaultQueryFreshness,
    }),
  }),
});

export const { useGetSoldListingsQuery } = soldListingsApi;
